import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, state } = useLocation();
  const prev = useRef(pathname);

  useEffect(() => {
    const stripLang = (p) => p.replace(/^\/(fr|en)/, "") || "/";
    const prevStripped = stripLang(prev.current);
    const currStripped = stripLang(pathname);
    const isLangSwitchOnly =
      prevStripped === currStripped || state?.skipScroll === true;
    prev.current = pathname;
    if (!isLangSwitchOnly) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [pathname, state]);

  return null;
}
